<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="4" md="2" lg="2" xl="2">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
              dense outlined hide-details class="mr-1">
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" md="2" lg="2" xl="2">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense
              outlined hide-details class="mr-1">
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" md="2" lg="2" xl="2">
        <v-text-field v-model="queryForm.vehicle_number" outlined dense label="车牌号" hide-details
          class="mr-1"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" md="1" lg="1" xl="1">
        <v-text-field v-model="queryForm.onstation" outlined dense label="上站信息" hide-details
          class="mr-1"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" md="1" lg="1" xl="1">
        <v-text-field v-model="queryForm.offstation" outlined dense label="下站信息" hide-details
          class="mr-1"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" md="1" lg="1" xl="1">
        <v-select outlined dense v-model="queryForm.match_state" label="状态" :items="[
          { text: '未匹配', value: 0 },
          { text: '已匹配', value: 1 },
        ]" clearable :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"></v-select>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" xl="3">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <UploadTask btnText="上传记录" btnColor="cyan" modelTitle="上传ETC消费记录"
            :alertText="`上传Excel文件需包含 <span class='error--text'>车牌号</span>、<span class='error--text'>交易时间</span>、<span class='error--text'>ETC卡号</span>、<span class='error--text'>交易金额</span>、<span class='error--text'>上站信息</span>、<span class='error--text'>下站信息</span>字段。`"
            uploadType="etcbill" :templateFile="templateFile" />
          <v-btn color="success" dark tile @click="download">
            <v-icon small>mdi-download</v-icon> 下载记录
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="[summaryRow, ...list]" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="trade_amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="pay_channel_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record._isSummary ? '' : record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="match_state" slot-scope="text, record">
          {{ record._isSummary ? '' : record.match_state == 1 ? '已匹配' : '未匹配' }}
        </template>
        <!-- <template slot="action" slot-scope="text, record">
          <a-space>
            <a-popconfirm title="删除ETC消费记录" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template> -->
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "EtcList",
  data() {
    return {
      start_day_menu: false,
      end_day_menu: false,
      queryForm: {
        start_day: "",
        end_day: "",
        vehicle_number: "",
        onstation: "",
        offstation: "", match_state: ""
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        // { title: "订单号", dataIndex: "order_number", scopedSlots: { customRender: "order_number" }, width: 150, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 120, align: "center" },
        { title: "状态", dataIndex: "match_state", scopedSlots: { customRender: "match_state" }, width: 120, align: "center" },
        // { title: "车辆类型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 120, align: "center" },
        { title: "车牌颜色", dataIndex: "vehicle_platecolor", scopedSlots: { customRender: "vehicle_platecolor" }, width: 120, align: "center" },
        { title: "交易时间", dataIndex: "trade_time", scopedSlots: { customRender: "trade_time" }, width: 120, align: "center" },//套牌号
        { title: "ETC卡号", dataIndex: "card_no", scopedSlots: { customRender: "card_no" }, width: 120, align: "center" },
        { title: "OBU编号", dataIndex: "obu_no", scopedSlots: { customRender: "obu_no" }, width: 120, align: "center" },
        { title: "交易金额(元)", dataIndex: "trade_amount", scopedSlots: { customRender: "trade_amount" }, width: 120, align: "center" },//元/月,包车费/月租,自动关联过来,临时车在调度计划里填写然后关联到路单和财务账单
        { title: "支付通道费(元)", dataIndex: "pay_channel_fee", scopedSlots: { customRender: "pay_channel_fee" }, width: 120, align: "center" },
        { title: "上站信息", dataIndex: "onstation", scopedSlots: { customRender: "onstation" }, width: 180, align: "center" },
        { title: "下站信息", dataIndex: "offstation", scopedSlots: { customRender: "offstation" }, width: 120, align: "center" },
        { title: "交易描述", dataIndex: "trade_desc", scopedSlots: { customRender: "trade_desc" }, width: 120, align: "center" },
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 180, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      templateFile: {
        url: `${process.env.BASE_URL}template/ETC交易记录导入模板.xlsx`,
        name: 'ETC交易记录导入模板.xlsx',
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    summaryRow() {
      if (!this.list || this.list.length === 0) return { _id: 'summary', _isSummary: true, vehicle_number: '合计' };
      const total = this.list.reduce((acc, row) => ({
        trade_amount: acc.trade_amount + (Number(row.trade_amount) || 0),
        pay_channel_fee: acc.pay_channel_fee + (Number(row.pay_channel_fee) || 0),
      }), { trade_amount: 0, pay_channel_fee: 0 });
      return {
        _id: 'summary',
        _isSummary: true,
        vehicle_number: '合计',
        trade_amount: total.trade_amount.toFixed(2),
        pay_channel_fee: total.pay_channel_fee.toFixed(2),
      };
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      start_day: start_day,
      end_day: end_day,
      vehicle_number: "",
      onstation: "",
      offstation: "",
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/list", { page: this.page, limit: this.limit, ...this.queryForm, action: "download" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/* ===== 强制缩小搜索栏每列宽度（绕过 Vuetify 栅格） ===== */
.etc-filter-row {
  display: flex !important;
  flex-wrap: wrap !important;
}

/* 按钮列：内容驱动宽度，不被压缩 */
.etc-filter-row>.col.flex-shrink-0 {
  flex: 0 1 auto !important;
  max-width: none !important;
}

/* 输入框强制紧凑 */
.etc-filter-row .v-input {
  font-size: 12px !important;
}

.etc-filter-row .v-input__control {
  min-height: 32px !important;
}

.etc-filter-row .v-text-field--outlined.v-input--dense .v-input__slot {
  min-height: 32px !important;
}

/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
